import React, { Component } from "react";
import { Row, Col, Input, Divider, Button, Empty } from "antd";
// import RmxImg from "../../assets/images/rmx-step.png";
import RmxCoverImg from "../../assets/images/cover.jpg";
import StLogoSmall from "../../assets/images/trkr-logo.png";
import { connect } from "react-redux";
import { UserAction, AuthAction } from "../../store/actions";
import CustomModal from "../../components/modals/customModal";
import { formatToNumber } from "../../config/utils";
import TextInput from "../../components/input/TextInput";
import { EMAIL_REGX } from "../../config/variables";
import "./index.css";

class AccountDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      isOpenPasswordModal: false,
      data: {},
      isOpenUserModal: false,
      image: {},
      isChangePassword: false,
      passwordPayload: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      errors: {
        current_passwordError: "",
        new_passwordError: "",
        confirm_passwordError: "",
      },
      userError: {
        business_nameError: "",
        emailError: "",
        phoneError: "",
      },
      userAccountError: {
        first_nameError: "",
        last_nameError: "",
        emailError: "",
        phoneError: "",
      },
    };
  }
  componentDidMount() {
    const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[0]?.user
      ?.id;
    console.log("UserID==>", userId);
    const platfromOwnerId = JSON.parse(
      localStorage.getItem("platform_owner")
    )?.[1]?.platform_owner?.id;
    this.props.getUserDetail(platfromOwnerId);
    this.props.getUserPlantOwner(userId);
  }

  toggleModal = () => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
    });
  };
  istoggleModal = () => {
    this.setState({
      isOpenPasswordModal: !this.state.isOpenPasswordModal,
    });
  };
  onHandleChanged = (e) => {
    const {
      target: { value, name },
    } = e;
    console.log("event==>", e.target.name);
    this.setState({
      data: { ...this.state.data, [name]: value },
      userError: { ...this.state.userError, [`${name}Error`]: "" },
      userAccountError: {
        ...this.state.userAccountError,
        [`${name}Error`]: "",
      },
    });
  };
  onChangePassword = (e) => {
    this.setState({
      passwordPayload: {
        ...this.state.passwordPayload,
        [e.target.name]: e.target.value,
      },
      errors: {
        ...this.state.errors,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  onSubmitUserInfo = () => {
    let { data, userError } = this.state;
    if (
      !data.business_name.trim().length ||
      !EMAIL_REGX.test(data.email) ||
      !data.phone.toString().trim().length ||
      data.phone.toString().trim().length < 10
    ) {
      if (!data.business_name.trim().length) {
        userError.business_nameError = "Business name is required";
      }
      if (!data.email.trim().length) {
        userError.emailError = "Email is required";
      }
      if (!data.phone.toString().trim().length || data.phone.toString().trim().length < 10) {
        userError.phoneError = "Phone Number is required";
      }
      this.setState({
        userError: this.state.userError,
      });
      return;
    }
    this.props.updateUserDetail(data, () =>
      this.setState({
        isOpenUserModal: false,
      })
    );
  };

  onSubmitUserAccountInfo = () => {
    let { data, userAccountError } = this.state;

    if (
      !data.first_name.trim().length ||
      !data.last_name.trim().length ||
      !EMAIL_REGX.test(data.email) ||
      !data?.phone?.toString()?.trim()?.length ||
      data?.phone?.toString()?.trim()?.length < 10
    ) {
      if (!data.first_name.trim().length) {
        userAccountError.first_nameError = "First name is required";
      }
      if (!data.last_name.trim().length) {
        userAccountError.last_nameError = "Last name is required";
      }
      if (!data.email.trim().length) {
        userAccountError.emailError = "Email is required";
      }
      if (!data?.phone?.toString()?.trim()?.length || data?.phone?.toString()?.trim()?.length < 10) {
        userAccountError.phoneError = "Phone Number is required";
      }
      this.setState({
        userAccountError: this.state.userAccountError,
      });
      return;
    }
    console.log("dataid===>", data.id);
    console.log("Checkingdata===>", data);
    this.props.updatePlatformUser(data.id, data, () => this.toggleModal());
  };

  onSubmitChangePassword = () => {
    let oldpassErr = "";
    let newPassErr = "";
    let valnewPassErr = "";
    let confPassErr = "";
    const { passwordPayload } = this.state;
    if (
      !passwordPayload.current_password.trim().length ||
      !passwordPayload.new_password.trim().length ||
      (!!passwordPayload.new_password.trim().length &&
        passwordPayload.new_password.trim().length < 8) ||
      passwordPayload.confirm_password !== passwordPayload.new_password
    ) {
      if (!passwordPayload.current_password.trim().length) {
        oldpassErr = "Old password is required";
        this.setState({
          errors: { ...this.state.errors, current_passwordError: oldpassErr },
        });
      }
      if (!passwordPayload.new_password.trim().length) {
        newPassErr = "New password is required";
        this.setState({
          errors: {
            ...this.state.errors,
            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
          },
        });
      }
      if (
        !!passwordPayload.new_password.trim().length &&
        passwordPayload.new_password.trim().length < 8
      ) {
        newPassErr = "password should be at least 8 characters long.";
        this.setState({
          errors: {
            ...this.state.errors,
            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
          },
        });
      }
      if (passwordPayload.confirm_password !== passwordPayload.new_password) {
        confPassErr = "Mismatch";
        this.setState({
          errors: {
            ...this.state.errors,
            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
            confirm_passwordError: confPassErr,
          },
        });
      }
      return;
    }
    const { confirm_password, ...rest } = this.state.passwordPayload;
    this.props.updatePassword(rest, () =>
      this.setState({
        isChangePassword: false,
        isOpenPasswordModal: !this.state.isOpenPasswordModal,
      })
    );
  };
  render() {
    const { userPlatfromOwnerDetails, userDetails } = this.props;
    const {
      isClose,
      isOpenModal,
      isOpenPasswordModal,
      data,
      isOpenUserModal,
      errors: {
        current_passwordError,
        new_passwordError,
        confirm_passwordError,
      },
      passwordPayload,
      userError: { business_nameError, emailError, phoneError },
      userAccountError,
    } = this.state;

    let imageRef;

    console.log("businessEro==>", business_nameError);

    return (
      <Row className="card-panel" style={{ marginTop: '10px' }}>
        <Col
          span={24}
          style={{ marginBottom: "25px", transition: "box-shadow .25s" }}
        >
          <Row>
            <Col
              xl={24}
              sm={24}
              xs={24}
              lg={24}
              md={24}
              className="account-settings cover-image"
              style={{
                backgroundImage: `url(${RmxCoverImg})`,
                marginBottom: "40px",
              }}
            ></Col>
            <Col xl={16} sm={24} xs={24} lg={24} md={24}>
              <Row>
                <Col span={5}>
                  <img
                    height="120"
                    width="120"
                    className="border-rounded pointer-cursor profile-image"
                    src={userPlatfromOwnerDetails?.image?.original}
                    style={{ objectFit: "cover" }}
                    onClick={() => imageRef.click()}
                  />
                </Col>
                <Col span={18}>
                  <Row>
                    <Col span={24} className="text-left">
                      <h5 className="profile-heading">Account Dashboard</h5>
                    </Col>
                    <Col span={24} className="text-left">
                      <p>
                        {`Hello, ${userPlatfromOwnerDetails?.first_name} ${userPlatfromOwnerDetails?.last_name}!`}
                      </p>
                    </Col>
                    <Col span={21} className="text-left">
                      <p>
                        From your account dashboard you have the ability to view
                        a snapshot of your recent account activity and update
                        your account information. Select a link below to view or
                        edit information.
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Col span={24} className="text-left">
                <Row style={{ paddingLeft: "30px" }} gutter={[0, 2]}>
                  <Col
                    className="text-left"
                    span={24}
                    style={{ marginBottom: "10px", marginTop: "20px" }}
                  >
                    <span>
                      <strong style={{ fontWeight: "bolder" }}>
                        Contact Information
                      </strong>
                    </span>
                  </Col>
                  <Col className="text-left" span={24}>
                    <span>
                      {`${userPlatfromOwnerDetails?.first_name} ${userPlatfromOwnerDetails?.last_name}`}
                    </span>{" "}
                  </Col>
                  <Col className="text-left" span={24}>
                    <span>{`${userPlatfromOwnerDetails?.email}`}</span>
                  </Col>
                  <Col className="text-left" span={24}>
                    <span>{`${formatToNumber(userPlatfromOwnerDetails?.phone || "")}`}</span>
                  </Col>
                  <Col className="text-left" span={24}>
                    <span>{`${userPlatfromOwnerDetails?.address}`}</span>
                  </Col>

                  <Col className="text-left  " span={24}>
                    <small
                      style={{
                        marginTop: "10px",
                        fontSize: "80%",
                        color: "#009688 ",
                        fontWeight: "bolder",
                      }}
                      className="pointer-cursor"
                      onClick={() =>
                        this.setState({
                          isOpenModal: !this.state.isOpenModal,
                          data: userPlatfromOwnerDetails,
                          userAccountError: {
                            first_nameError: "",
                            last_nameError: "",
                            emailError: "",
                            phoneError: "",
                          },
                        })
                      }
                    >
                      EDIT
                    </small>
                  </Col>
                  <Col className="text-left" span={24}>
                    <small
                      style={{
                        marginTop: "10px",
                        fontSize: "80%",
                        color: "#009688 ",
                        fontWeight: "bolder",
                      }}
                      className="pointer-cursor"
                      onClick={() =>
                        this.setState({
                          isOpenPasswordModal: !this.isOpenPasswordModal,
                          errors: {
                            current_passwordError: "",
                            new_passwordError: "",
                            confirm_passwordError: "",
                          },
                          passwordPayload: {
                            current_password: "",
                            new_password: "",
                            confirm_password: "",
                          },
                        })
                      }
                    >
                      CHANGE/RESET PASSWORD
                    </small>
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col
              xl={8}
              sm={24}
              xs={24}
              lg={24}
              md={24}
              style={{
                borderLeft: "1px solid lightgrey",
                height: "60%",
                minHeight: "60%",
              }}
            >
              <Row gutter={[0, 10]}>
                <Col span={5}>
                  <img
                    height="60"
                    width="60"
                    className="border-rounded pointer-cursor"
                    // src={userPlatfromOwnerDetails?.image?.original}
                    src={StLogoSmall}
                    style={{ objectFit: "cover", border: "1px solid #e5e5e5" }}
                  />
                </Col>
                <Col span={19}>
                  <Row>
                    <Col span={24} className="text-left">
                      <h5 className="rmx-profile-heading"> Main Frame LLC</h5>
                    </Col>
                    <Col span={24} className="text-left">
                      <small className="rmx-profile-link" onClick={() => window.open("https://main-frame.com")}>
                        https://main-frame.com
                      </small>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ paddingLeft: "15px" }} gutter={[0, 2]}>
                <Col
                  className="text-left"
                  span={24}
                  style={{ marginBottom: "10px", marginTop: "20px" }}
                >
                  <span>
                    <strong style={{ fontWeight: "bolder" }}>
                      Contact Information
                    </strong>
                  </span>
                </Col>
                <Col className="text-left" span={24}>
                  <span>{`${userDetails?.business_name}`}</span>
                </Col>
                <Col className="text-left" span={24}>
                  <span>{`${userDetails?.email}`}</span>
                </Col>
                <Col className="text-left" span={24}>
                  <span>{`${formatToNumber(userDetails?.phone || "")}`}</span>
                </Col>
                <Col className="text-left" span={24}>
                  <span>{`${userDetails?.address}`}</span>
                </Col>
                <Col className="text-left  " span={24}>
                  <small
                    style={{
                      marginTop: "10px",
                      fontSize: "80%",
                      color: "#009688 ",
                    }}
                    className="pointer-cursor"
                    onClick={() =>
                      this.setState({
                        isOpenUserModal: true,
                        data: userDetails,
                        userError: {
                          business_nameError: "",
                          emailError: "",
                          phoneError: "",
                        },
                      })
                    }
                  >
                    EDIT
                  </small>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <CustomModal
          visible={isOpenUserModal}
          onCancelModal={() =>
            this.setState({
              isOpenUserModal: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => this.onSubmitUserInfo()}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit Info</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[10, 10]}>
                    <Col xl={24}>
                      <TextInput
                        label="Business Name "
                        name="business_name"
                        onChange={this.onHandleChanged}
                        value={data.business_name}
                        required
                      />
                      <span className="danger-color">
                        {business_nameError && business_nameError}
                      </span>
                    </Col>

                    <Col xl={24}>
                      <TextInput
                        label="Email"
                        required
                        name="email"
                        onChange={this.onHandleChanged}
                        value={data.email}
                      />
                      <span className="danger-color">
                        {emailError && emailError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Phone"
                        name="phone"
                        required
                        type="text"
                        onChange={this.onHandleChanged}
                        value={formatToNumber(data?.phone || "")}
                        maxLength={15}
                      />
                      <span className="danger-color">
                        {phoneError && phoneError}
                      </span>
                    </Col>

                    <Col xl={24}>
                      <TextInput
                        name="address"
                        label="Address"
                        onChange={this.onHandleChanged}
                        value={data.address}
                      />
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <CustomModal
          visible={isOpenModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => this.onSubmitUserAccountInfo()}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit User Info</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[10, 10]}>
                    <Col xl={24}>
                      <TextInput
                        label="First Name "
                        name="first_name"
                        onChange={this.onHandleChanged}
                        value={data.first_name}
                        required
                      />
                      <span className="danger-color">
                        {userAccountError.first_nameError &&
                          userAccountError.first_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Last Name "
                        name="last_name"
                        onChange={this.onHandleChanged}
                        value={data.last_name}
                        required
                      />
                      <span className="danger-color">
                        {userAccountError.last_nameError &&
                          userAccountError.last_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Email"
                        required
                        name="email"
                        onChange={this.onHandleChanged}
                        value={data.email}
                      />
                      <span className="danger-color">
                        {userAccountError.emailError &&
                          userAccountError.emailError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Phone"
                        name="phone"
                        required
                        type="text"
                        onChange={this.onHandleChanged}
                        value={formatToNumber(data.phone || "")}
                        maxLength={15}
                      />
                      <span className="danger-color">
                        {userAccountError.phoneError &&
                          userAccountError.phoneError}
                      </span>
                    </Col>

                    <Col xl={24}>
                      <TextInput
                        name="address"
                        label="Address"
                        onChange={this.onHandleChanged}
                        value={data.address}
                      />
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
        <CustomModal
          visible={isOpenPasswordModal}
          onCancelModal={this.istoggleModal}
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => this.onSubmitChangePassword()}
            >
              Save
            </Button>,
          ]}
          width={350}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Reset/Change Password</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={22}>
                <form>
                  <Row justify="space-between" gutter={[15, 10]}>
                    <Col xl={24}>
                      <TextInput
                        label="Old Password"
                        name="current_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.current_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {current_passwordError && current_passwordError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="New Password"
                        name="new_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.new_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {new_passwordError && new_passwordError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Confirm Password"
                        name="confirm_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.confirm_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {confirm_passwordError && confirm_passwordError}
                      </span>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <input
          type="file"
          ref={(ref) => (imageRef = ref)}
          className="d-none"
          onChange={(e) =>
            this.props.updatePlatformUser(userPlatfromOwnerDetails.id, {
              image: e.target.files[0],
            })
          }
        />
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    userDetails: store.UserReducer.userDetails,
    userPlatfromOwnerDetails: store.UserReducer.userPlatfromOwnerDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetail: (userId) => dispatch(UserAction.getUserDetailReq(userId)),
    getUserPlantOwner: (platformuserId) =>
      dispatch(UserAction.getUserPlatfromOwnerReq(platformuserId)),
    updatePlatformUser: (id, payload, cb) =>
      dispatch(UserAction.updateUserPlatfromOwnerReq(id, payload, cb)),
    updateUserDetail: (payload, cb) =>
      dispatch(UserAction.updatePlatfromOwnerReq(payload, cb)),
    updatePassword: (payload, cb) =>
      dispatch(AuthAction.updatePasswordReq(payload, cb)),
    changePassword: (body, cb) => dispatch(AuthAction.ResetPassword(body, cb)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountDashboard);
